import Header from "./components/Header";
import Hero from "./components/Hero";
import Sobre from "./components/Sobre";
import AreasAtuacao from "./components/AreasAtuacao";
import Problema from "./components/Problema";
import Solucao from "./components/Solucao";
import ComoFunciona from "./components/ComoFunciona";
import Diferenciais from "./components/Diferenciais";
import CTAForte from "./components/CTAForte";
import Contato from "./components/Contato";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <main className="font-sans bg-white">
      <Header />
      {/* Início */}
      <Hero />
      {/* Sobre */}
      <Sobre />
      {/* Áreas de Atuação */}
      <AreasAtuacao />
      {/* Revisão de Juros */}
      <Problema />
      <Solucao />
      <ComoFunciona />
      <Diferenciais />
      <CTAForte />
      {/* Contato */}
      <Contato />
      <Footer />
    </main>
  );
}
